module.exports = __webpack_public_path__ + "img/274196640_112705991339911_3413444126020455097_n.0a2ba9eb.jpg";